import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import SeparateLine from '../../../../Common/seperateLine';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import { convertStringDateToLocalTimestamp } from '../../../../Common/dateFormater';
import { Icon } from '@iconify/react';
import { useMutation, useQuery } from 'react-query';
import { exportProfileInformation, fetchProfileByCustomerId, fetchProfileWithLimitList, setProfileAccessibilityById } from '../../../../api';
import { checkForAPISuccess, checkIfNoRecords, showErrorToast, showInfoToast, showSuccessToast } from './../../../../Common/commonFunctions';
import { useDispatch } from 'react-redux';
import { SET_PROFILES, UPDATE_PROFILE_ACCESS_STATUS } from '../../../../store/actions';
import Dropdown from 'react-bootstrap/Dropdown';
import CustomToggle from '../../Common/CustomToggle';
import ToolTip from '../../Common/Tooltip';
import { ClipLoader } from 'react-spinners';
import { Link, useHistory } from 'react-router-dom';
import { RESPONSE_CATEGORY_UNAPPLIED_EQUIPMENT_UNITS_CODE } from './../../../../Common/constants';

const RecentProfileList = props => {

	const [utils, setUtils] = useState({
		name: '', id: '',
		isLocked: false, profilesList: [],
		isCategoryNotAppliedUnitsPresent: false,
		profileToExport: { id: "", name: "" }
	});

	const dispatch = useDispatch();
	const history = useHistory();
	const useQueryConfiguration = { enabled: false, retry: false, refetchOnWindowFocus: false, retryOnMount: false, refetchOnMount: false };

	const menu = useSelector(store => store.menu);
	const profilesList = useSelector(store => store.profiles.profiles);

	const updateLockStatus = async () => {
		const response = await setProfileAccessibilityById({ profileId: utils.id, lockStatus: !utils.isLocked });
		return response?.data;
	}

	const updateLockStatusQuery = useQuery('update-profile-accessibility', updateLockStatus, { ...useQueryConfiguration });

	const getProfilesByCustomerId = async () => {
		const response = await fetchProfileByCustomerId(history.location.pathname.split('/')[2]);
		return response?.data;
	}

	const getProfilesByCustomerIdQuery = useQuery('get-customer-based-profiles', getProfilesByCustomerId, { ...useQueryConfiguration });

	const getProfilesByCount = async () => {
		const response = await fetchProfileWithLimitList(10);
		return response.data;
	}

	const getProfilesByCountQuery = useQuery('get-count-based-profiles', getProfilesByCount, { ...useQueryConfiguration });

	const exportProfileInfo = async (generateInfo) => {
		const response = await exportProfileInformation({
			"profileId": generateInfo.id,
			"isForceGenerate": generateInfo.isForceGenerate,
			"isIncludeJson": generateInfo.isIncludeJson
		});
		if(response.headers["content-type"] === "application/zip") {
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
			link.download = generateInfo.name + "_Dashboard-Export.zip";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			setUtils({ ...utils, isCategoryNotAppliedUnitsPresent: false, profileToExport: {} });
		}
		else if(response.headers["content-type"] === "application/json") {
			let responseJson = JSON.parse(new TextDecoder().decode(response.data));
			if(responseJson?.statusCode === RESPONSE_CATEGORY_UNAPPLIED_EQUIPMENT_UNITS_CODE) {
				setUtils({ ...utils, isCategoryNotAppliedUnitsPresent: true, profileToExport : { id: generateInfo.id, name: generateInfo.name } });
			}
			else {
				showErrorToast("Failed to export profile information.")
			}
		}
	}

	const exportProfileInfoMutation = useMutation(exportProfileInfo);

	const dropDownOption = (className, callBack, message, icon) => 
		<Dropdown.Item className={className} onClick={() => callBack()}>
			<div>{message}</div> {icon}
		</Dropdown.Item>

	useEffect(() => {
		if (history.location.pathname.split('/').includes('customer')) {
			getProfilesByCustomerIdQuery.refetch();
		}
		else {
			getProfilesByCountQuery.refetch();
		}
	}, [props.selectedCustomerId]);

	useEffect(() => {
		setUtils({ ...utils, profilesList: props.useSearch.filterList(profilesList, 'name'), name: "", id: "", isLocked: false });
	}, [props.useSearch.searchValue, profilesList]);

	useEffect(() => {
		if(getProfilesByCountQuery.isFetched) {
			if(checkForAPISuccess(getProfilesByCountQuery?.data?.statusCode)) {
				dispatch({ type: SET_PROFILES, payload: getProfilesByCountQuery?.data?.data });
			}
			else if(checkIfNoRecords(getProfilesByCountQuery?.data?.statusCode)) {
				showInfoToast("No profiles found", 5000);
			}
			else {
				showErrorToast("Failed to fetch profiles", 5000);
			}
			getProfilesByCountQuery.remove();
		}
		if(getProfilesByCustomerIdQuery.isFetched) {
			if(checkForAPISuccess(getProfilesByCustomerIdQuery?.data?.statusCode) || checkIfNoRecords(getProfilesByCustomerIdQuery?.data?.statusCode)) {
				dispatch({ type: SET_PROFILES, payload: getProfilesByCustomerIdQuery?.data?.data });
			}
			else {
				showErrorToast("Failed to fetch profiles for selected customer", 5000);
			}
			getProfilesByCustomerIdQuery.remove();
		}
		if(updateLockStatusQuery.isFetched) {
			if(checkForAPISuccess(updateLockStatusQuery?.data?.statusCode)) {
				showSuccessToast(`Profile ${utils.isLocked ? 'unlocked' : 'locked'} successfully`);
				dispatch({ type: UPDATE_PROFILE_ACCESS_STATUS, payload: { id: utils.id, lockStatus: !utils.isLocked } });
			}
			else {
				showErrorToast("Failed to update profile accessibility");
			}

			updateLockStatusQuery.remove()
		}
	}, [getProfilesByCountQuery.isFetched, getProfilesByCustomerIdQuery.isFetched, updateLockStatusQuery.isFetched]);

	return (
		<>
			<Card.Body className="scrollable-card ">
				<PerfectScrollbar style={{ height: window.innerHeight - 140 }}>
					{
						!_.isEmpty(utils.profilesList) ?
							(
								utils.profilesList.map((profile, key) => {
									return (
										<div key={key} className={menu?.items[1].id !== 'recent_profile' ? 'div-rec-select' : 'div-rec-select pointer'}>
											<div className="d-flex justify-content-end" />
											<div className="d-flex justify-content-between">
												<div className="mr-auto p2 pb-0 element_center ml-1">
													<h6>
														<Link to={{ pathname: `/profile/${profile.profileId}`, state: profile }}>
															<span style={{ color: '#075978' }} className="pointer">{profile.name}</span>
														</Link>
														<ToolTip
															toolTipKey={`${profile.profileId}`}
															toolTipValue={`${profile.isLocked ? 'Locked ' : 'Unlocked'} profile`}
															overlayComponent={
																<Icon
																	className={`cursor-pointer ml-2 p-0 color-${profile.isLocked ? 'red' : 'green'}`}
																	icon={`feather-${profile.isLocked ? 'lock' : 'unlock'}`}
																/>
															}
														/>
													</h6>
													<h6 className="text-color-grey">
														<span>{profile.customerName}</span>
													</h6>
												</div>
												<div className="p2 pb-0 element_center mr-2 text-right">
													<h6 className="text-color-grey">
														{
															!_.isEmpty(profile.datetimeLocallyUpdated) &&
															convertStringDateToLocalTimestamp(profile.datetimeLocallyUpdated, 'MM-dd-YYYY HH:MM:SS')
														}
													</h6>
													<div className="text-color-grey">{profile.deploymentLocation}</div>
												</div>
												<Dropdown className="mt-3 mr-2" drop="left">
													<Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
														<Icon icon="feather:more-vertical"></Icon>
													</Dropdown.Toggle>
													<Dropdown.Menu alightRight={true}>
														{
															dropDownOption(
																"profile-list-dropdown",
																() => setUtils({ ...utils, name: profile.name, id: profile.profileId, isLocked: profile.isLocked }),
																profile.isLocked ? 'Unlock profile' : 'Lock profile',
																<Icon
																	className={`mt-1 ml-1 color-${profile.isLocked ? 'green' : 'red'}`}
																	icon={`feather-${profile.isLocked ? 'unlock' : 'lock'}`}
																/>
															)
														}
														{
															dropDownOption(
																"profile-list-dropdown",
																() => exportProfileInfoMutation.mutate({
																	id: profile.profileId,
																	isIncludeJson: false,
																	name: profile.name,
																	isForceGenerate: false
																}),
																"Export marriage file"
															)
														}
														{
															dropDownOption(
																"profile-list-dropdown",
																() => exportProfileInfoMutation.mutate({
																	id: profile.profileId,
																	isIncludeJson: true,
																	name: profile.name,
																	isForceGenerate: false
																}),
																"Export marriage file & JSON"
															)
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
											<SeparateLine className="underLine" />
										</div>
									);
								})
							)
								:
							<div>
								<h5 className="mt-5 text-center">NO PROFILES FOUND</h5>
							</div>
					}
				</PerfectScrollbar>
			</Card.Body>
			<Modal backdrop="static" show={!_.isEmpty(utils.name)} onHide={() => setUtils({ ...utils, name: "", id: "", isLocked: "" })}>
				<Modal.Header closeButton={!updateLockStatusQuery.isFetching}>
					<b>Profile {utils.isLocked ? 'unlock' : 'lock'} : {utils.name}</b>
				</Modal.Header>
				<Modal.Body>
					<center className="font-weight-bold my-5">
						{
							updateLockStatusQuery.isFetching ?
								<ClipLoader color="#075978" />
									:
								<>
									Are you sure to {utils.isLocked ? 'unlock' : 'lock'} the profile and
									{utils.isLocked ? ' allow' : ' restrict'} updates to it?
								</>
						}
					</center>
				</Modal.Body>
				{
					!updateLockStatusQuery.isFetching && (
						<Modal.Footer>
							<Button
								onClick={() => setUtils({ ...utils, id: '', name: '', isLocked: false })}
								style={{ backgroundColor: 'white', border: '1px solid #075978', color: '#075978' }}
								className="btn"
							>
								No
							</Button>
							<Button onClick={() => updateLockStatusQuery.refetch()} className="btn btn-primary">
								Yes
							</Button>
						</Modal.Footer>
					)
				}
			</Modal>
			<Modal
				onHide={() => setUtils({ ...utils, isCategoryNotAppliedUnitsPresent: false, profileToExport: { id: '', name: '' } })}
				backdrop="static"
				show={utils.isCategoryNotAppliedUnitsPresent || exportProfileInfoMutation.isLoading}
			>
				{ utils.isCategoryNotAppliedUnitsPresent && <Modal.Header closeButton /> }
				<Modal.Body className='text-center'>
					{
						exportProfileInfoMutation.isLoading ?
							<div className='my-5'>
								<ClipLoader className='mb-2' color='#075978' />
								<h5>Exporting profile</h5>
							</div>
								:
							<center className='my-5 f-17'>
								Category unapplied equipment units are present. <br/> 
								Do you want to continue the export ?
							</center>
					}
				</Modal.Body>
				{
					utils.isCategoryNotAppliedUnitsPresent &&
						<Modal.Footer>
							<Button
								disabled={exportProfileInfoMutation.isLoading}
								onClick={() => setUtils({ ...utils, isCategoryNotAppliedUnitsPresent: false, profileToExport: { id: '', name: '' } })}
								className='secondary-button'
							>
								Cancel
							</Button>
							<Button
								disabled={exportProfileInfoMutation.isLoading}
								onClick={
									() =>
										exportProfileInfoMutation.mutate({
											id: utils.profileToExport.id,
											isIncludeJson: true,
											name: utils.profileToExport.name,
											isForceGenerate: true
										})
								}
							>
								Continue
							</Button>
						</Modal.Footer>
				}
			</Modal>
		</>
	);
};

export default RecentProfileList;
